<template>
  <div class="bg-white border border-grayLight rounded-[12px] p-5 h-full flex flex-col">
    <!-- Header -->
    <div class="flex items-center justify-between mb-4">
      <h3 class="text-[14px] font-semibold text-bodyText">Time Tracking</h3>
    </div>

    <!-- Loading -->
    <div v-if="loading" class="flex-1 flex items-center justify-center">
      <div class="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primaryDarkBg"></div>
    </div>

    <div v-else class="flex-1 flex flex-col border border-grayLight rounded-[10px] px-4 py-3 min-h-0">
      <!-- Today's total -->
      <p class="text-[12px] text-grayDark mb-1">Today's Tracked Time</p>
      <p class="text-[22px] font-semibold text-primaryDarkBg mb-3">{{ formattedTotalTime }}</p>

      <!-- Distribution -->
      <p class="text-[12px] text-grayDark mb-2">Distribution</p>

      <div class="flex-1 overflow-y-auto space-y-2 min-h-0">
        <div
          v-if="projectsToday.length === 0"
          class="bg-[#EEF6E7] rounded-[10px] px-4 py-3 text-center"
        >
          <p class="text-[12px] text-grayDark">No activity tracked today.</p>
        </div>
        <div
          v-for="(project, index) in projectsToday"
          :key="index"
          class="bg-[#EEF6E7] rounded-[10px] px-4 py-3 flex flex-col"
        >
          <span class="text-[12px] text-grayDark">{{ project.name }}</span>
          <span class="text-[15px] font-semibold text-grayDark mt-1">{{ formattedTime(project.timeSpent) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from '@/axios';

export default {
  name: 'DashboardTimeTrackingCard',
  data() {
    return {
      loading: true,
      totalTimeSpent: 0,
      projectsToday: [],
    };
  },
  computed: {
    isManager() {
      return this.$store.getters.isManager;
    },
    isTalent() {
      return this.$store.getters.isTalent;
    },
    formattedTotalTime() {
      const seconds = Number(this.totalTimeSpent) || 0;
      if (seconds <= 0) return '0h 0m';
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      return `${hours}h ${minutes}m`;
    },
  },
  methods: {
    formattedTime(seconds) {
      const s = Number(seconds) || 0;
      const hours = Math.floor(s / 3600);
      const minutes = Math.floor((s % 3600) / 60);
      return `${hours}h ${minutes}m`;
    },
    async fetchTimeData() {
      try {
        this.loading = true;
        const response = await apiClient.get('/web/dashboard/manager/time-tracked');
        const data = response.data;

        this.totalTimeSpent = data.total_time_tracked_seconds || 0;

        this.projectsToday = (data.projects || [])
          .filter(p => p.time_tracked_seconds > 0)
          .sort((a, b) => b.time_tracked_seconds - a.time_tracked_seconds)
          .map(p => ({
            name: p.project_name || 'Project',
            timeSpent: p.time_tracked_seconds,
          }));
      } catch (error) {
        console.error('Error fetching time tracking data:', error);
        this.projectsToday = [];
        this.totalTimeSpent = 0;
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.fetchTimeData();
  },
};
</script>
